/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 15:01:03
 * @LastEditTime: 2022-03-18 15:42:37
 * @LastEditors: Yandong Hu
 * @Description:
 */
import { useEffect, useState } from "react";
import mblockService from "../../services/mblock.service";
import "./waiting.scss";

export const Waiting = () => {
  const [on, setOn] = useState(true);
  const checkWaiting = () => {
    mblockService.checkMblockObject().then((_) => setOn(false));
  };
  useEffect(() => {
    checkWaiting();
  });
  return on ? <div className="waiting">正在加载.....</div> : null;
};
